import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_000.jpg';

//   {
//     id: 'page016_game7',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 250,
//     },
//   },
//   {
//     id: 'page016_game8',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 500,
//     },
//   },
//   {
//     id: 'page016_game9',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 750,
//     },
//   },
//   {
//     id: 'page007_game3',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1000,
//     },
//   },
//   {
//     id: 'page027_game8',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1250,
//     },
//   },
//   {
//     id: 'page027_game9',
//     tooltip: '',
//     icon: 'ikonaStepbystep',
//     pos: {
//       x: LEFT,
//       y: 1500,
//     },
//   },
// ];
// page.paint = [
//   {
//     id: 'page000_file7',
//     icon: 'ikona_cw1',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     paintObj: {
//       text: 'Blada, blada, blada.',
//       audio: 'audio/test.mp3',
//       item: {
//         path: 'informatyka/files/page000/link2B_paint-pusty.bmp',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 1680,
//     },
//     rectangle: {
//       id: 'page000_rect7',
//     },
//   },
// ];
// page.word = [
//   {
//     id: 'page000_file8',
//     icon: 'ikona_cw2',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Dupa, dupa, dupa.',
//       audio: 'audio/test.mp3',
//       item: {
//         path: 'informatyka/files/page000/link1D_word-zawod.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 1860,
//     },
//     rectangle: {
//       id: 'page000_rect8',
//     },
//   },
// ];
// page.rectangle = [
//   {
//     id: 'page000_rect7',
//
//     tooltip: '',
//     color: '#FF000000',
//     linked: ['page000_file7'],
//     x: 1000,
//     y: 100,
//     width: 100,
//     height: 100,
//   },
//   {
//     id: 'page000_rect8',
//
//     tooltip: '',
//     color: '#FF000000',
//     linked: ['page000_file8'],
//     x: 1150,
//     y: 100,
//     width: 100,
//     height: 100,
//   },
// ];

export default page;
